<template>
  <div class="content">
    <div class="md-layout">
      <div
        class="md-layout-item md-medium-size-50 md-xsmall-size-100 md-size-25"
      >
        <stats-card data-background-color="green">
          <template slot="header">
            <font-awesome-icon class="fs-3" :icon="['fas', 'charging-station']" />
            <span class="fs-6">Day</span>
          </template>

          <template slot="content">
            <p class="category">本日發電量</p>
            <h3 class="title">{{all_plant_stats.today.kwh_str}}
              <br>
              <small>kWh</small>
            </h3>
          </template>

          <template slot="footer">
            <div class="stats d-flex align-items-center">
              <md-icon>paid</md-icon>
              本日節省電費：
              <h4>{{all_plant_stats.today.fee_str}}</h4>
              <small>元</small>
            </div>
          </template>
        </stats-card>
      </div>
      <div
        class="md-layout-item md-medium-size-50 md-xsmall-size-100 md-size-25"
      >
        <stats-card data-background-color="orange">
          <template slot="header">
            <font-awesome-icon class="fs-3" :icon="['fas', 'charging-station']" />
            <span class="fs-6">Month</span>
          </template>

          <template slot="content">
            <p class="category">本月發電量</p>
            <h3 class="title">{{all_plant_stats.month.kwh_str}}
              <br>
              <small>kWh</small>
            </h3>
          </template>

          <template slot="footer">
            <div class="stats d-flex align-items-center">
              <md-icon>paid</md-icon>
              本月節省電費：
              <h4>{{all_plant_stats.month.fee_str}}</h4>
              <small>元</small>
            </div>
          </template>
        </stats-card>
      </div>
      <div
        class="md-layout-item md-medium-size-50 md-xsmall-size-100 md-size-25"
      >
        <stats-card data-background-color="blue">
          <template slot="header">
            <font-awesome-icon class="fs-3" :icon="['fas', 'charging-station']" />
            <span class="fs-6">Year</span>
          </template>


          <template slot="content">
            <p class="category">本年發電量</p>
            <h3 class="title">{{all_plant_stats.year.kwh_str}}
              <br>
              <small>kWh</small>
            </h3>
          </template>

          <template slot="footer">
            <div class="stats d-flex align-items-center">
              <md-icon>paid</md-icon>
              本年節省電費：
              <h4>{{all_plant_stats.year.fee_str}}</h4>
              <small>元</small>
            </div>
          </template>
        </stats-card>
      </div>
      <!-- <div
        class="md-layout-item md-medium-size-50 md-xsmall-size-100 md-size-25"
      >
        <stats-card data-background-color="red">
          <template slot="header">
            <md-icon>info_outline</md-icon>
          </template>

          <template slot="content">
            <p class="category">Fixed Issues</p>
            <h3 class="title">75</h3>
          </template>

          <template slot="footer">
            <div class="stats">
              <md-icon>local_offer</md-icon>
              Tracked from Github
            </div>
          </template>
        </stats-card>
      </div> -->
    </div>

    <div class="alert alert-success d-flex align-items-center" role="alert" v-if="all_plant_state === 0">
      <font-awesome-icon :icon="['fas', 'check-circle']" />
      <div class="ms-2">
        正常
      </div>
    </div>
    <div class="alert alert-danger d-flex align-items-center" role="alert" v-else-if="all_plant_state === 1">
      <font-awesome-icon :icon="['fas', 'exclamation-triangle']" />
      <div class="ms-2">
        一級警報
      </div>
    </div>
    <div class="alert alert-warning d-flex align-items-center" role="alert" v-else-if="all_plant_state === 2">
      <font-awesome-icon :icon="['fas', 'exclamation']" />
      <div class="ms-2">
        二級警報
      </div>
    </div>
    <div class="alert alert-secondary d-flex align-items-center" role="alert" v-else-if="all_plant_state === 3">
      <font-awesome-icon :icon="['fas', 'times']" />
      <div class="ms-2">
        設備斷線
      </div>
    </div>
    <div class="alert alert-white d-flex align-items-center" role="alert" v-else>
      <div class="ms-2">
        取得數據中....
      </div>
    </div>
    

    <div class="md-layout">
      <pv-plant-card v-for="info in plant_information" v-bind:key="info._id" v-bind:info="info"></pv-plant-card>
    </div>
  </div>
</template>

<script>
import {
  StatsCard,
  pvPlantCard
} from "@/components";

import PvPlantCard from '../components/dashboard/pvPlantCard.vue';

export default {
  components: {
    StatsCard,
    PvPlantCard,
  },
  data() {
    return {
      plant_information: [],
      all_plant_state: null,
      all_plant_stats: {},
    }
  },
  methods: {
    getTime(){
      //console.log("Get time")
    },
    create_pvPlantCard(){
      let that = this
      this.axios.get("/pv_plant_information")
      .then(function (data) {
        //console.log(data.data)
        that.plant_information = data.data.information
        that.all_plant_state = data.data.all_plant_state
        that.all_plant_stats = data.data.all_plant_stats
      })
    },
    set_interval_update(){
      this.syncdata = setInterval(this.create_pvPlantCard, 5000)
    }
  },
  mounted(){
    let that = this
    this.axios.get("/get_system_notify")
    .then(function (data) {
      if(data.data.data != null){
        alert(data.data.data)
      }
    })
  },
  beforeMount(){
    this.create_pvPlantCard(),
    this.set_interval_update()
  },
  destroyed(){
    clearInterval(this.syncdata)
  }
};
</script>
<style>
  .plant_image{
    /* object-fit: none;  *//* Do not scale the image */
    object-position: center; /* Center the image within the element */
    width: 100% !important;
    max-height: 75vh !important;
  }
  body{
    background-color: #ece7e7 !important;
  }
</style>